"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Variant_1 = require("../../../behaviorManager/constants/Variant");
var errors_1 = require("../../../errors");
var ContainsAllCondition = (function () {
    function ContainsAllCondition(variant, values) {
        this.variant = variant;
        this.values = values;
    }
    ContainsAllCondition.prototype.evaluate = function (resolverFactory) {
        var resolver = resolverFactory.getLookupResolver(this.variant);
        if (this.values && this.values.length > 0) {
            return this.values.every(function (value) { return resolver.getBy(value) === value; });
        }
        throw new errors_1.ConditionEvalError('values is null or empty');
    };
    ContainsAllCondition.prototype.describe = function () {
        return "".concat(Variant_1.Variant[this.variant], ".containsAll(").concat(this.values.join(', '), ")");
    };
    return ContainsAllCondition;
}());
exports.default = ContainsAllCondition;
